import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../../../redux/configureStore';
import getApurationAccounts from '../../../../../../redux/fetchActions/legadoPage/apurationApp';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import SetFinalDate from './components/SetFinalDate';
import SetInitialDate from './components/SetInitialDate';
import SetPartner from './components/SetPartner';

export function ApurationFilter() {
  const dispatch = useDispatch();

  const faresFilterState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );

  function dispatchData() {
    dispatch(
      getApurationAccounts(
        faresFilterState.partner,
        faresFilterState.initialDate,
        faresFilterState.finalDate
      )
    );
  }

  function searchFare() {
    if (
      moment(faresFilterState.initialDate) > moment(faresFilterState.finalDate)
    ) {
      return Swal.fire({
        icon: 'error',
        title: 'A data inicial não pode ser maior que a data final!',
        confirmButtonText: 'Tentar novamente',
      });
    }
    dispatchData();
    return null;
  }

  return (
    <Filter.Default>
      <SetPartner />
      <SetInitialDate />
      <SetFinalDate />
      <SearchButton
        onClick={() => searchFare()}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export default ApurationFilter;
